/**
 * Small book icon that opens a journal entry (`/accounting/journal-entries/:id`). Renders nothing without an id or
 * without finance read access, so it can sit in any row.
 */

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { MenuBook } from '@mui/icons-material';
import { can } from '../../utils/roleUtils';

const sessionUser = () => {
  try { return JSON.parse(localStorage.getItem('currentUser') || '{}'); } catch (e) { return {}; }
};

const JournalEntryLink = ({ id, title = 'View journal entry' }) => {
  if (!id || !can(sessionUser(), 'finance', 'read')) return null;
  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        component={RouterLink}
        to={`/accounting/journal-entries/${id}`}
        onClick={(e) => e.stopPropagation()}
        sx={{ p: 0.25, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
      >
        <MenuBook sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};

export default JournalEntryLink;
